/**
 * @fileoverview Two-factor verification card.
 * @description The white card shown inside AuthLayout on the /two-factor route: logo plus
 * TwoFactorForm. Mirrors AuthCard/ForgotPasswordCard's logo/card chrome so every auth screen reads
 * as one family.
 * @copyright Copyright (c) 2026 Brownbox Consulting. All rights reserved.
 * @author Rahul Chawda
 */

import logoUrl from '@/assets/images/login/logo.png'
import TwoFactorForm from '@/features/auth/components/TwoFactorForm'

/**
 * @component
 */
function TwoFactorCard() {
  return (
    <div className="flex w-full flex-col items-center">
      <img src={logoUrl} alt="InsightBox" className="mb-2 h-18 sm:h-22 lg:h-24 w-auto" />
      <div
        className="mt-8 w-full rounded-[18px] border border-primary/10 bg-white p-6 shadow-card sm:p-8 lg:p-10"
        data-testid="two-factor-card"
      >
        <TwoFactorForm />
      </div>
    </div>
  )
}

export default TwoFactorCard
